import { IconFont, Tag, Text, Tooltip } from '@byecode/ui'
import type { PageAbstract } from '@lighthouse/core'
import { useAtomAction, useAtomData } from '@lighthouse/shared'
import cls from 'classnames'
import React from 'react'
import styled from 'styled-components'

import { AppSystemPageAtom } from '@/atoms/application/state'
import { ModuleType } from '@/components/ApplicationSetting/type'

interface SystemPageProps {
    data: PageAbstract
    id?: string
}

const SCxContainer = styled.div`
    display: flex;
    gap: 4px;
    height: 36px;
    align-items: center;
    padding: 8px 12px 8px 28px;
    border-radius: 6px;
    cursor: pointer;
    &:hover {
        background: var(--color-gray-100);
    }
    &.active {
        background: var(--color-gray-100);
    }
`

export const SystemPage: React.FunctionComponent<SystemPageProps> = ({ data, id }) => {
    const { run: setAppSystemPage } = useAtomAction(AppSystemPageAtom)
    return (
        <SCxContainer
            className={cls({ active: data.id === id })}
            onClick={() => {
                setAppSystemPage(data.id)
            }}
        >
            <IconFont type="SignIn" size={16} color="var(--color-gray-400)" />
            <Text lineHeight="16px" color="var(--color-black)" size={14}>
                {data.name}
            </Text>
            <Tooltip title="该页面是系统页面，不可删除和复制">
                <Text
                    style={{
                        height: 20,
                        borderRadius: 4,
                        lineHeight: '20px',
                        background: 'var(--color-gray-100)',
                        width: 36,
                        fontSize: 12,
                        marginLeft: 4,
                        textAlign: 'center'
                    }}
                    color="var(--color-gray-400)"
                >
                    系统
                </Text>
            </Tooltip>
        </SCxContainer>
    )
}
